/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

// Pass-through route for /operator/:chat_id — React Router handles rendering
// inside the React island mounted by the parent route's template.
export class OperatorChatRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  reactEnabled() {
    return this.appService.app?.canUseFeature('team-self-serve-ai-onboarding') ?? false;
  }

  beforeModel() {
    if (!this.reactEnabled()) {
      this.router.replaceWith('apps.app.operator.index');
    }
  }
}

export default ReactRoute(OperatorChatRoute);
